import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'

function renderConfirmDialog(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate('misc.titles.confirm.clone'),
        value: this.showDialog,
        maxWidth
      },
      on: {
        input: value => {
          this.showDialog = value
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'pa-3'
        },
        [ this.getTranslate('misc.contents.confirm.clone') ]
      ),

      h(
        'div',
        {
          class: 'dialog__footer',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat,
                rounded: true
              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          ),
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.clone'),
                color: Colors.primary

              },
              on: {
                click: () => {
                  this._clone()
                }
              }
            }
          )
        ]
      )
    ]
  )
}

export default function(h) {
  return h(
    button,
    {
      props: {
        icon: icons.copy_all,
        mode: buttonModes.flat,
        color: Colors.secondary,
        loading: this.loading,
        disabled: this.loading,
        tooltip: this.getTranslate('misc.tooltips.clone')
      },
      scopedSlots: {
        dialog: () => {
          return renderConfirmDialog.call(this, h)
        }
      },
      key: this.value.id,
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
